import { is, can } from '@/extensions/permissions'

const withPrefix = (routes: Array<any>) => {
    let excluded: string[] = [];

    // Optional: add permission-based route exclusion here
    const permissions: Record<string, string> = {
        // 'view users': 'users',
        // Add permission:routeName pairs here if needed
    };

    for (const [permission, routeName] of Object.entries(permissions)) {
        if (!can(permission)) {
            excluded.push(routeName);
        }
    }

    return routes.filter(route => {
        // Exclude by permission name
        if (excluded.includes(route.name)) return false;

        // Exclude by role (meta.role)
        if (route.meta?.role && !is(route.meta.role)) return false;

        return true;
    }).map(route => {
        // Always ensure meta exists
        if (!route.meta) {
            route.meta = {};
        }

        return route;
    });
};

export { withPrefix };